import React, { useEffect, useState } from 'react'
import { FormGroup, Label, Col, Input, FormFeedback } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import { apiCountries } from 'api'

const SelectCountry = ({ title, value, className = null, classnameForm= null, name, onChange, disabled = false, error, required = false }) => {
  const [countries, setCountries] = useState([])

  useEffect(() => {
    apiCountries.get().then(({ data }) => setCountries(data.results || []))
  }, [])

  return (
    <FormGroup row className={classnameForm}>
      {title && (
        <Col sm='4' className={className}>
          <Label>{I18n.t(title)}</Label>
        </Col>
      )}

      <Col sm={title ? '8' : '12'}>
        <Input bsSize='sm' type='select' name={name} value={value || ''} onChange={onChange} disabled={disabled} invalid={error} required={required}>
          {title ? <option value=''>{I18n.t(title)}</option> : !value && <option value=''>{I18n.t('select_country')}</option>}
          {countries.map((country, i) => (
            <option key={country.codigo_pais_alpha2 + i} value={country.codigo_pais_alpha2}>
              {country.nombre}
            </option>
          ))}
        </Input>

        <FormFeedback>{error ? I18n.t('dashboard_errors_required-field') : ''}</FormFeedback>
      </Col>
    </FormGroup>
  )
}

export default SelectCountry
